import { render } from "./StandingsSunB.vue?vue&type=template&id=5944ca4a&scoped=true"
import script from "./StandingsSunB.vue?vue&type=script&scoped=true&lang=js"
export * from "./StandingsSunB.vue?vue&type=script&scoped=true&lang=js"

import "./StandingsSunB.vue?vue&type=style&index=0&id=5944ca4a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5944ca4a"]])

export default __exports__